import { render, staticRenderFns } from "./MbScriptField.vue?vue&type=template&id=5dce7868&"
import script from "./MbScriptField.vue?vue&type=script&lang=js&"
export * from "./MbScriptField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports